{
  "企业 Logo": "Company logo",
  "这个地址在这个后台里没有对应的页面。": "There is no page at this address.",
  "返回运营工作台": "Back to operations workbench",
  "页面出错了": "Something went wrong",
  "重试": "Retry",
  "设备授权": "Device authorization",
  "核对设备上的授权码": "Check the authorization code on your device",
  "无访问权限": "Access denied",
  "当前账号没有访问 {{path}} 的权限。": "Your account does not have permission to access {{path}}.",
  "忘记密码": "Forgot password",
  "留下注册邮箱，我们会发送一封重置密码的邮件": "Enter your registered email to receive a password reset link",
  "登录": "Sign in",
  "欢迎回来": "Welcome back",
  "登录爱出海运营后台": "Sign in to the iGlobal operations console",
  "一次性令牌登录": "Sign in with a one-time token",
  "在已登录设备的安全设置中生成令牌，再粘贴到这里。": "Generate a token in security settings on a signed-in device, then paste it here.",
  "返回密码登录": "Back to password sign-in",
  "注册": "Sign up",
  "创建账号": "Create account",
  "填写账号信息，开启你的管理工作空间。": "Enter your account details to start managing your workspace.",
  "重置密码": "Reset password",
  "链接无法直接使用": "This link cannot be used",
  "链接不完整或已失效": "Link incomplete or expired",
  "这个地址里没有重置令牌，通常是邮件客户端把链接截断了。请从邮件里重新打开，或申请一封新的重置邮件。": "The reset token is missing. Your email app may have cut off the link. Open it again from the email or request a new reset email.",
  "链接里的令牌无效。令牌只能使用一次，且会过期。": "The token in this link is invalid. Tokens expire and can only be used once.",
  "重新申请重置邮件": "Request a new reset email",
  "设置一个新密码，然后回到登录页": "Set a new password, then return to sign in",
  "密码已重置，请使用新密码登录": "Password reset. Sign in with your new password.",
  "邮箱验证": "Email verification",
  "验证邮箱，确保账号安全与消息送达。": "Verify your email to secure your account and receive messages.",
  "返回登录": "Back to sign in",
  "运营工作台": "Operations workbench",
  "你好，{{name}}": "Hello, {{name}}",
  "用户总数": "Total users",
  "启用中": "Active",
  "已停用": "Disabled",
  "近 7 天新增": "New in the last 7 days",
  "用户创建趋势（近 14 天，UTC）": "New users (last 14 days, UTC)",
  "近 14 天用户创建趋势": "New users over the last 14 days",
  "最近创建的用户": "Recently created users",
  "全部用户": "All users",
  "还没有用户": "No users yet",
  "详情": "Details",
  "启用": "Enable",
  "API 状态": "API status",
  "服务状态": "Service status",
  "检测中": "Checking",
  "正常": "Normal",
  "运行时长": "Uptime",
  "最近一次探测": "Last checked",
  "基本设置": "General settings",
  "安全设置": "Security settings",
  "协议与隐私": "Agreements and privacy",
  "个人中心": "My account",
  "确认退出登录？": "Sign out?",
  "退出后需重新登录才能继续使用。": "You will need to sign in again to continue.",
  "退出登录": "Sign out",
  "取消": "Cancel",
  "设置新密码": "Set new password",
  "首次登录必须先修改管理员发放的初始密码": "Change the initial password provided by your administrator before continuing",
  "首次登录，请先修改管理员提供的初始密码": "For your first sign-in, change the initial password provided by your administrator.",
  "修改当前账号的密码": "Change your account password",
  "密码已更新，其它设备上的会话已失效": "Password updated. Sessions on other devices have been revoked.",
  "系统设置": "System settings",
  "外观": "Appearance",
  "恢复默认": "Restore defaults",
  "主题模式": "Theme",
  "浅色": "Light",
  "深色": "Dark",
  "主色": "Primary color",
  "整体布局": "Layout",
  "紧凑模式": "Compact mode",
  "文书": "Document",
  "配置管理": "Configuration",
  "隐私与协议": "Privacy and agreements",
  "新建隐私与协议": "New privacy policy or agreement",
  "还没有任何文书，先新建一篇": "No documents yet. Create one to get started.",
  "日志管理": "Logs",
  "追查操作记录、请求结果与运行异常": "Review operations, request results, and runtime errors",
  "字典 #{{id}}": "Dictionary #{{id}}",
  "字典": "Dictionary",
  "字典不存在": "Dictionary not found",
  "“{{id}}”不是一个合法的字典编号。": "“{{id}}” is not a valid dictionary ID.",
  "返回字典列表": "Back to dictionaries",
  "返回列表": "Back to list",
  "字典信息": "Dictionary details",
  "编号": "ID",
  "字典名称": "Dictionary name",
  "字典编码": "Dictionary code",
  "状态": "Status",
  "字典项": "Dictionary items",
  "{{count}} 项": "{{count}} items",
  "{{count}} 项_one": "{{count}} item",
  "{{count}} 项_other": "{{count}} items",
  "创建时间": "Created at",
  "更新时间": "Updated at",
  "备注": "Notes",
  "新建字典项": "New dictionary item",
  "对外查询": "Public query",
  "编辑": "Edit",
  "字典管理": "Dictionaries",
  "新建字典": "New dictionary",
  "还没有任何字典，先新建一个": "No dictionaries yet. Create one to get started.",
  "Redis 缓存": "Redis cache",
  "查看 Redis 运行状态、内存占用与缓存命中情况": "View Redis status, memory usage, and cache hit rates",
  "服务监控": "Service monitoring",
  "查看当前 API 实例的运行时间、CPU 信息与内存状态": "View uptime, CPU information, and memory usage for this API instance",
  "会话管理": "Sessions",
  "按用户查看有效登录会话，并撤销单条或全部会话": "View active sessions by user and revoke individual or all sessions",
  "用户 #{{id}}": "User #{{id}}",
  "用户": "User",
  "用户不存在": "User not found",
  "“{{id}}”不是一个合法的用户编号。": "“{{id}}” is not a valid user ID.",
  "返回用户列表": "Back to users",
  "基本信息": "Basic information",
  "姓名": "Name",
  "邮箱": "Email",
  "所属部门": "Department",
  "未分配": "Unassigned",
  "部门 #{{id}}": "Department #{{id}}",
  "手机号": "Phone number",
  "未填写": "Not provided",
  "性别": "Gender",
  "生日": "Birthday",
  "账号身份": "Account role",
  "照片": "Photos",
  "{{count}} 张": "{{count}} photos",
  "{{count}} 张_one": "{{count}} photo",
  "{{count}} 张_other": "{{count}} photos",
  "登录凭据": "Sign-in credentials",
  "账号状态": "Account status",
  "停用这个用户？": "Disable this user?",
  "重新启用这个用户？": "Re-enable this user?",
  "仅停用当前租户档案；资料和照片保留，不影响其他租户。": "Only this tenant profile will be disabled. Details and photos are retained; other tenants are unaffected.",
  "恢复当前租户访问，不影响其他租户或账号封禁。": "Restore access to this tenant without affecting other tenants or account bans.",
  "停用": "Disable",
  "用户已停用": "User disabled",
  "用户已启用": "User enabled",
  "停用用户": "Disable user",
  "重新启用用户": "Re-enable user",
  "用户管理": "Users",
  "新建用户": "New user",
  "为保护账号，请退出并重新登录后再管理设备": "For your security, sign out and sign in again before managing devices.",
  "邮箱或密码错误": "Invalid email or password",
  "用户名或密码错误": "Invalid username or password",
  "密码错误": "Incorrect password",
  "邮箱格式不正确": "Invalid email address",
  "请先验证邮箱": "Please verify your email first",
  "邮箱已验证": "Email verified",
  "用户无效": "Invalid user",
  "用户已存在": "User already exists",
  "用户已存在，请使用其他邮箱": "User already exists. Use another email.",
  "用户名已被使用": "Username is already taken",
  "用户名过短": "Username is too short",
  "用户名过长": "Username is too long",
  "用户名格式不正确": "Invalid username",
  "显示用户名格式不正确": "Invalid display username",
  "用户名不可修改": "Username cannot be changed",
  "密码过短": "Password is too short",
  "密码过长": "Password is too long",
  "此账号已设置密码": "This account already has a password",
  "此账号已设置密码，请提供密码以删除账号": "This account has a password. Enter it to delete the account.",
  "令牌无效或已过期，请重新生成": "Token invalid or expired. Generate a new one.",
  "会话无效，请重新登录": "Invalid session. Please sign in again.",
  "会话已过期，请重新登录": "Session expired. Please sign in again.",
  "请先登录": "Please sign in first",
  "账号已被封禁，请联系管理员": "This account is banned. Contact your administrator.",
  "验证码错误": "Incorrect verification code",
  "备用码无效或已被使用": "Backup code invalid or already used",
  "两步验证会话已失效，请重新登录": "Two-factor session expired. Please sign in again.",
  "验证码已过期，请重新获取": "Verification code expired. Request a new one.",
  "尚未开启一次性验证码": "One-time codes are not enabled",
  "一次性验证码暂不可用": "One-time codes are unavailable",
  "尚未开启认证器验证": "Authenticator verification is not enabled",
  "认证器验证已开启": "Authenticator verification is already enabled",
  "认证器验证暂不可用": "Authenticator verification is unavailable",
  "尚未开启两步验证": "Two-factor authentication is not enabled",
  "尚未启用备用码": "Backup codes are not enabled",
  "尝试次数过多，请重新获取验证码": "Too many attempts. Request a new verification code.",
  "验证失败次数过多，账号已暂时锁定，请稍后重试": "Too many failed attempts. Your account is temporarily locked. Try again later.",
  "请求过于频繁，请稍后重试": "Too many requests. Try again later.",
  "人机验证失败，请重试": "CAPTCHA verification failed. Try again.",
  "请先完成人机验证": "Please complete the CAPTCHA first",
  "安全验证暂不可用": "Security verification is unavailable",
  "验证码配置不完整，请联系管理员": "CAPTCHA configuration is incomplete. Contact your administrator.",
  "设备授权码无效": "Invalid device authorization code",
  "设备授权码已过期": "Device authorization code expired",
  "正在等待设备授权": "Waiting for device authorization",
  "此设备授权请求已处理": "This device authorization request has already been processed",
  "请先查看设备授权请求": "Review the device authorization request first",
  "设备授权请求状态无效": "Invalid device authorization request status",
  "创建账号失败，请重试": "Failed to create account. Try again.",
  "更新账号失败，请重试": "Failed to update account. Try again.",
  "创建登录会话失败，请重试": "Failed to create session. Try again.",
  "获取登录会话失败，请重试": "Failed to retrieve session. Try again.",
  "获取用户信息失败，请重试": "Failed to retrieve user information. Try again.",
  "未获取到账号邮箱": "Account email was not returned",
  "该第三方账号已关联": "This social account is already linked",
  "此登录方式暂不可用": "This sign-in method is unavailable",
  "未找到密码登录凭据": "Password sign-in credentials not found",
  "账号不存在": "Account not found",
  "邮箱不可修改": "Email cannot be changed",
  "暂不允许修改邮箱": "Email changes are disabled",
  "邮箱不匹配": "Email does not match",
  "邮箱验证暂不可用": "Email verification is unavailable",
  "创建验证请求失败，请重试": "Failed to create verification request. Try again.",
  "不能解除最后一个登录账号的关联": "You cannot unlink your last sign-in account",
  "请检查填写的信息": "Please check the information you entered",
  "请填写必填信息": "Please complete the required fields",
  "不允许修改此字段": "This field cannot be changed",
  "认证请求失败": "Authentication request failed",
  "邮箱密码": "Email and password",
  "用户名密码": "Username and password",
  "邮箱验证码": "Email verification code",
  "暂无记录": "No records yet",
  "未获取到一次性令牌": "No one-time token was returned",
  "未获取到登录会话": "No sign-in session was returned",
  "后端启用了非 TOTP 的两步验证方式，本页只支持认证器应用（TOTP）": "The server uses a different two-factor method. This page only supports authenticator apps (TOTP).",
  "未收到备用码，请重试": "No backup codes were returned. Try again.",
  "验证码配置加载失败，请重试": "Failed to load CAPTCHA configuration. Try again.",
  "安全验证": "Security verification",
  "验证码加载失败，请检查网络后重试": "Failed to load CAPTCHA. Check your connection and try again.",
  "验证码配置加载失败": "Failed to load CAPTCHA configuration",
  "人机验证": "CAPTCHA",
  "请检查网络或联系管理员，验证恢复前不能提交。": "Check your connection or contact your administrator. Submission is unavailable until verification is restored.",
  "正在加载人机验证…": "Loading CAPTCHA…",
  "验证已过期，请重新验证": "Verification expired. Please verify again.",
  "请重新完成安全验证": "Please complete security verification again",
  "必须先修改初始密码": "Change your initial password first",
  "管理员为 {{email}} 设置了初始密码，请先修改后再使用其它功能。": "An administrator set an initial password for {{email}}. Change it before using other features.",
  "请输入当前密码": "Enter your current password",
  "当前密码": "Current password",
  "请输入管理员给你的初始密码": "Enter the initial password from your administrator",
  "新密码": "New password",
  "至少 {{min}} 位": "At least {{min}} characters",
  "{{min}}–128 位，建议使用密码管理器生成": "{{min}}–128 characters. We recommend generating it with a password manager.",
  "两次输入的密码不一致": "Passwords do not match",
  "确认新密码": "Confirm new password",
  "请再次输入新密码": "Enter your new password again",
  "修改并继续": "Change and continue",
  "修改密码": "Change password",
  "修改成功后，其它设备上的登录会被注销，需要用新密码重新登录。": "Changing your password signs out other devices. Sign in again with the new password.",
  "请输入有效的设备授权码": "Enter a valid device authorization code",
  "授权请求不可用或不属于当前账号": "This authorization request is unavailable or belongs to another account",
  "设备授权操作失败": "Device authorization failed",
  "设备已授权": "Device authorized",
  "已拒绝设备授权": "Device authorization denied",
  "设备授权码": "Device authorization code",
  "客户端": "Client",
  "请求权限": "Requested permissions",
  "仅允许你本人正在使用且授权码一致的设备。": "Only approve a device you are using with a matching authorization code.",
  "允许授权": "Approve",
  "拒绝授权": "Deny",
  "重新输入": "Enter again",
  "查看请求": "Review request",
  "请求已提交": "Request submitted",
  "如果这个邮箱对应一个账号，我们已经向它发送了一封重置密码的邮件。请检查收件箱与垃圾邮件文件夹；链接有有效期，过期后可以再申请一次。": "If an account exists for this email, we have sent a password reset email. Check your inbox and spam folder. The link expires; you can request another if needed.",
  "想起来了？": "Remembered your password?",
  "注册时使用的邮箱": "Email used to sign up",
  "出于安全考虑，无论该邮箱是否存在，页面都会给出同一句提示。": "For security, the same message is shown whether or not the email exists.",
  "发送重置密码邮件": "Send password reset email",
  "已经有密码？": "Already have a password?",
  "冒充状态": "Impersonation status",
  "正在冒充 {{name}}；当前操作使用该用户的权限。": "Impersonating {{name}}. Actions use this user's permissions.",
  "{{error}}。若原会话已失效，请退出并重新登录。": "{{error}}. If your original session has expired, sign out and sign in again.",
  "停止冒充": "Stop impersonating",
  "登录成功": "Signed in",
  "上次使用：{{method}}": "Last used: {{method}}",
  "请输入邮箱或用户名": "Enter your email or username",
  "邮箱或用户名": "Email or username",
  "忘记密码？": "Forgot password?",
  "请输入密码": "Enter your password",
  "密码": "Password",
  "使用一次性令牌": "Use a one-time token",
  "重新验证邮箱": "Verify email again",
  "还没有账号？": "Don't have an account?",
  "注册一个账号": "Create an account",
  "或使用以下账号继续": "Or continue with",
  "使用 {{provider}} 账号继续": "Continue with {{provider}}",
  "上次使用": "Last used",
  "需要两步验证": "Two-factor authentication required",
  "请输入保存的备用码，完成身份验证。": "Enter a saved backup code to verify your identity.",
  "打开认证器应用，输入当前显示的 6 位验证码。": "Open your authenticator app and enter the current 6-digit code.",
  "请输入备用码": "Enter a backup code",
  "请输入 6 位验证码": "Enter a 6-digit verification code",
  "备用码": "Backup code",
  "6 位验证码": "6-digit verification code",
  "例如 a1b2c3d4-e5f6...": "For example, a1b2c3d4-e5f6...",
  "验证并进入": "Verify and continue",
  "验证码用不了？": "Can't use your verification code?",
  "改用 6 位验证码": "Use a 6-digit code instead",
  "使用备用码": "Use a backup code",
  "返回上一步": "Go back",
  "请输入一次性令牌": "Enter a one-time token",
  "一次性令牌": "One-time token",
  "粘贴一次性令牌": "Paste a one-time token",
  "验证并登录": "Verify and sign in",
  "注册请求已受理，请验证邮箱后登录": "Sign-up request received. Verify your email before signing in.",
  "注册成功": "Account created",
  "如果该邮箱可以注册，验证邮件已发送；请检查收件箱和垃圾邮件，完成验证后返回登录。": "If this email can be registered, a verification email has been sent. Check your inbox and spam folder, then return to sign in after verifying.",
  "重新发送验证邮件": "Resend verification email",
  "请输入姓名": "Enter your name",
  "确认密码": "Confirm password",
  "请再次输入密码": "Enter your password again",
  "已经有账号？": "Already have an account?",
  "重置成功后不会自动登录，请返回登录页使用新密码进入。": "Resetting your password does not sign you in automatically. Return to sign in with your new password.",
  "链接无效？": "Link not working?",
  "重新申请重置密码邮件": "Request a new password reset email",
  "用认证器应用扫描二维码": "Scan the QR code with your authenticator app",
  "也可以用下面的密钥手动添加。扫描后输入应用生成的 6 位验证码来完成开启——在此之前两步验证尚未生效。": "You can also add the key below manually. Enter the app's 6-digit code to finish setup. Two-factor authentication is not active until you do.",
  "手动输入的密钥": "Manual setup key",
  "请扫描二维码完成设置。": "Scan the QR code to complete setup.",
  "复制密钥": "Copy key",
  "已复制": "Copied",
  "确认是本人操作": "Confirm your identity",
  "下一步": "Next",
  "两步验证已开启": "Two-factor authentication enabled",
  "请输入 6 位数字验证码": "Enter a 6-digit numeric verification code",
  "确认并开启": "Confirm and enable",
  "这些备用码只会显示这一次": "These backup codes are shown only once",
  "每个备用码可以使用一次，用于手机丢失或认证器应用不可用时登录。请立即保存到密码管理器或打印出来；关闭本窗口后无法再次查看。": "Each backup code can be used once to sign in if you lose your phone or cannot use your authenticator. Save them in a password manager or print them now. They cannot be viewed after this window closes.",
  "复制全部备用码": "Copy all backup codes",
  "我已保存，完成": "Saved, finish",
  "旧备用码将立即失效": "Old backup codes will stop working immediately",
  "确认密码后重新生成，请及时保存新的备用码。": "Confirm your password to generate new backup codes, then save them.",
  "确认重新生成": "Confirm regeneration",
  "两步验证已关闭": "Two-factor authentication disabled",
  "关闭后只用密码即可登录": "After disabling, only your password is needed to sign in",
  "关闭两步验证": "Disable two-factor authentication",
  "验证你的邮箱": "Verify your email",
  "输入注册时使用的邮箱，我们会发送验证链接。收到邮件后，点击链接完成验证。": "Enter the email you used to sign up. We will send a verification link. Open it to verify your email.",
  "正在验证邮箱…": "Verifying email…",
  "这个地址现在可以正常接收系统邮件了。": "This address can now receive system emails.",
  "验证失败": "Verification failed",
  "{{reason}} 令牌可能已过期或已被使用，请在下面重新发送一封验证邮件。": "{{reason}} The token may have expired or already been used. Request a new verification email below.",
  "已请求重发，如果这个邮箱对应一个尚未验证的账号，验证邮件已经再次发出。": "Request received. If this email belongs to an unverified account, another verification email has been sent.",
  "查看详情": "View details",
  "显示名": "Display name",
  "管理员": "Administrator",
  "普通用户": "Standard user",
  "已验证": "Verified",
  "未验证": "Unverified",
  "注册时间": "Registered at",
  "{{date}}（{{relative}}）": "{{date}} ({{relative}})",
  "最近登录方式": "Last sign-in method",
  "认证用户 ID": "Authentication user ID",
  "头像": "Avatar",
  "个人头像": "Profile picture",
  "请选择 JPG、PNG 或 WebP 图片": "Select a JPG, PNG, or WebP image",
  "图片不能为空且不能超过 2 MB": "The image must not be empty or exceed 2 MB",
  "头像已更新": "Avatar updated",
  "更换头像": "Change avatar",
  "JPG / PNG / WebP，最大 2 MB": "JPG / PNG / WebP, up to 2 MB",
  "其他设备已退出": "Other devices signed out",
  "该会话已撤销": "Session revoked",
  "我的登录设备": "My signed-in devices",
  "本人在所有设备上的有效会话": "Your active sessions across all devices",
  "没有有效的登录会话": "No active sessions",
  "退出其他所有设备？": "Sign out all other devices?",
  "保留当前会话，其他设备需要重新登录。": "Keep this session. Other devices will need to sign in again.",
  "确认退出": "Confirm sign-out",
  "退出其他设备": "Sign out other devices",
  "撤销此设备的登录会话？": "Revoke this device's session?",
  "确认撤销": "Confirm revocation",
  "撤销会话": "Revoke session",
  "未知设备": "Unknown device",
  "当前设备": "This device",
  "未知": "Unknown",
  "IP：{{ip}} · 登录于 {{createdAt}} · 到期 {{expiresAt}}": "IP: {{ip}} · Signed in {{createdAt}} · Expires {{expiresAt}}",
  "验证邮件发送请求已提交，请前往邮箱查看": "Verification email requested. Check your inbox.",
  "登录用户名": "Sign-in username",
  "已设置：{{username}}": "Set: {{username}}",
  "未设置，可设置用户名用于密码登录": "Not set. Set a username to sign in with a password.",
  "设置用户名": "Set username",
  "账户密码": "Account password",
  "管理员设置的是初始密码：修改之前，除本页之外的接口都会返回 403": "Your administrator set an initial password. Other endpoints return 403 until you change it.",
  "当前密码已设置，修改后其它设备上的会话会被立即撤销": "A password is set. Changing it immediately revokes sessions on other devices.",
  "修改": "Change",
  "两步验证": "Two-factor authentication",
  "已开启，登录时需要认证器应用生成的 6 位验证码": "Enabled. Sign-in requires a 6-digit code from your authenticator app.",
  "未开启，开启后登录除密码外还需要认证器应用生成的 6 位验证码": "Disabled. Enable to require a 6-digit authenticator code in addition to your password.",
  "关闭": "Close",
  "开启": "Enable",
  "两步验证备用码": "Two-factor backup codes",
  "重新生成后旧备用码立即失效，新码仅在本次窗口中显示": "Regenerating immediately invalidates old codes. New codes are shown only in this window.",
  "重新生成备用码": "Regenerate backup codes",
  "已验证邮箱：{{email}}": "Verified email: {{email}}",
  "未验证邮箱：{{email}}，收不到系统的密码重置邮件": "Unverified email: {{email}}. System password reset emails cannot be received.",
  "重新发送": "Resend",
  "在你自己的其他浏览器或设备使用当前登录会话": "Use your current session in another browser or device you own",
  "生成一次性令牌": "Generate one-time token",
  "登录会话": "Sign-in sessions",
  "当前会话将于 {{date}} 到期（{{relative}}）": "This session expires {{date}} ({{relative}})",
  "启用两步验证": "Enable two-factor authentication",
  "用户名已保存": "Username saved",
  "该账号在这台浏览器上的会话已撤销": "This account's session in this browser has been revoked",
  "登录于 {{createdAt}}，将于 {{expiresAt}} 到期（{{relative}}）": "Signed in {{createdAt}}; expires {{expiresAt}} ({{relative}})",
  "多账号会话": "Multiple account sessions",
  "本浏览器保存的账号": "Accounts saved in this browser",
  "这台浏览器还没有保存其它账号；再登录一个账号后，它会出现在这里": "No other accounts saved in this browser. Sign in to another account to see it here.",
  "切换": "Switch",
  "撤销这个账号的会话？": "Revoke this account's session?",
  "该账号在这台浏览器上会被登出。": "This account will be signed out of this browser.",
  "撤销": "Revoke",
  "当前会话": "Current session",
  "令牌已复制": "Token copied",
  "复制失败，请手动复制令牌": "Copy failed. Copy the token manually.",
  "持有者可使用当前会话，仅用于你自己的设备。3 分钟内有效，只能使用一次；任一端退出后会话失效。": "The holder can use your current session. Use only on your own devices. Valid for 3 minutes and one use. Signing out on either device ends the session.",
  "生成的一次性令牌": "Generated one-time token",
  "到期：{{date}}": "Expires: {{date}}",
  "复制令牌": "Copy token",
  "生成令牌": "Generate token",
  "请输入 3–30 位字母、数字、下划线或点": "Enter 3–30 letters, numbers, underscores, or dots",
  "用户名": "Username",
  "3–30 位，保存为小写；修改后请使用新用户名或邮箱登录。": "3–30 characters, saved in lowercase. Sign in with the new username or email after changing it.",
  "保存用户名": "Save username",
  "请填写{{label}}": "Enter {{label}}",
  "{{label}}最长 {{max}} 个字符": "{{label}} must not exceed {{max}} characters",
  "标题": "Title",
  "版本": "Version",
  "摘要": "Summary",
  "请填写文书键": "Enter a document key",
  "文书键最长 64 个字符": "Document key must not exceed 64 characters",
  "只能使用小写字母、数字和连字符": "Use only lowercase letters, numbers, and hyphens",
  "排序需要是整数": "Sort order must be an integer",
  "排序不能超过 9999": "Sort order must not exceed 9999",
  "内容过长": "Content is too long",
  "请填写内容": "Enter content",
  "已记录": "Recorded",
  "用户协议": "User agreement",
  "隐私条款": "Privacy policy",
  "数据安全说明": "Data security",
  "文书目录不完整": "Document catalog is incomplete",
  "我已阅读并同意《用户协议》": "I have read and agree to the User Agreement",
  "我已阅读《隐私条款》": "I have read the Privacy Policy",
  "完成": "Done",
  "隐私告知": "Privacy notice",
  "单独同意": "Separate consent",
  "编辑文书 {{key}}": "Edit document {{key}}",
  "文书已创建": "Document created",
  "文书已更新": "Document updated",
  "文书键": "Document key",
  "例如：cookie-notice": "For example: cookie-notice",
  "文书键不可修改。": "The document key cannot be changed.",
  "小写字母、数字和连字符。privacy 已留给隐私条款地址。": "Lowercase letters, numbers, and hyphens. The privacy path is reserved for the privacy policy.",
  "种类": "Kind",
  "种类不可修改。": "The kind cannot be changed.",
  "种类决定确认动作，创建后不能改": "The kind determines the confirmation action and cannot be changed after creation",
  "更改版本后，需要重新确认。": "Changing the version requires confirmation again.",
  "草案": "Draft",
  "已定稿": "Final",
  "排序": "Sort order",
  "数字小的排在前面": "Lower numbers appear first",
  "内容": "Content",
  "保存": "Save",
  "创建": "Create",
  "操作": "Actions",
  "查看": "View",
  "隐私与协议列表": "Privacy and agreements",
  "删除文书「{{title}}」？": "Delete document “{{title}}”?",
  "公开地址不再打开这篇文书。已有确认记录仍保留，且不可撤销。": "The public URL will no longer open this document. Existing confirmations are retained and cannot be revoked.",
  "删除": "Delete",
  "已删除文书「{{title}}」": "Deleted document “{{title}}”",
  "本稿为草案，正式正文待运营主体补齐并审定后生效。": "This is a draft. The final document takes effect after the operator completes and approves it.",
  "协议同意": "Agreement consent",
  "告知确认": "Notice acknowledgment",
  "尚未确认当前版本": "Current version not yet confirmed",
  "已于 {{date}} 确认版本 {{version}}": "Version {{version}} confirmed on {{date}}",
  "确认当前版本": "Confirm current version",
  "{{kind}}。{{acceptance}}": "{{kind}}. {{acceptance}}",
  "{{summary}} 业务入口尚未接入。": "{{summary}} The business workflow is not connected yet.",
  "查看全文": "Read full document",
  "写下协议或隐私条款": "Write the agreement or privacy policy",
  "图片已上传": "Image uploaded",
  "请求来源无效，请从本站重新登录": "Invalid request origin. Sign in again from this site.",
  "登录跳转地址无效": "Invalid sign-in redirect URL",
  "缺少登录跳转地址": "Sign-in redirect URL is missing",
  "认证配置不正确，请联系管理员": "Authentication is not configured correctly. Contact your administrator.",
  "请求格式不正确": "Invalid request format",
  "不能封禁自己的账号": "You cannot ban your own account",
  "不能删除自己的账号": "You cannot delete your own account",
  "不能冒充管理员": "You cannot impersonate administrators",
  "角色类型无效": "Invalid role type",
  "没有需要更新的数据": "No data to update",
  "请使用专用的密码设置操作": "Use the dedicated password setting action",
  "已达到租户数量上限": "Tenant limit reached",
  "租户已存在": "Tenant already exists",
  "租户标识已被使用": "Tenant identifier is already taken",
  "租户不存在": "Tenant not found",
  "用户不属于此租户": "User is not a member of this tenant",
  "你不属于此租户": "You are not a member of this tenant",
  "请先选择租户": "Select a tenant first",
  "用户已是此租户成员": "User is already a member of this tenant",
  "成员不存在": "Member not found",
  "角色不存在": "Role not found",
  "团队已存在": "Team already exists",
  "团队不存在": "Team not found",
  "请先转移所有权，再退出租户": "Transfer ownership before leaving the tenant",
  "已邀请该用户加入此租户": "This user has already been invited to the tenant",
  "邀请不存在或已失效": "Invitation not found or expired",
  "此邀请不属于当前账号": "This invitation belongs to another account",
  "邀请人已离开此租户": "The inviter is no longer a member of this tenant",
  "获取邀请失败，请重试": "Failed to retrieve invitation. Try again.",
  "已达到团队数量上限": "Team limit reached",
  "不能删除最后一个团队": "Cannot delete the last team",
  "已达到租户成员数量上限": "Tenant member limit reached",
  "已达到邀请数量上限": "Invitation limit reached",
  "已达到团队成员数量上限": "Team member limit reached",
  "用户不属于此团队": "User is not a member of this team",
  "请先选择团队": "Select a team first",
  "请先加入租户，再创建角色": "Join a tenant before creating a role",
  "已达到角色数量上限": "Role limit reached",
  "权限包含无效资源": "Permission includes an invalid resource",
  "角色名称已被使用": "Role name is already taken",
  "不能删除预定义角色": "Cannot delete a predefined role",
  "请先为成员分配其他角色，再删除此角色": "Assign members to another role before deleting this role",
  "团队编号包含保留字符": "Team ID contains a reserved character",
  "客户端无效": "Invalid client",
  "授权无效或已过期": "Authorization invalid or expired",
  "认证服务异常，请稍后重试": "Authentication service error. Try again later.",
  "不支持此授权类型": "This authorization type is not supported",
  "密码须包含字母和数字": "Password must contain letters and numbers",
  "{{min}}–64 位，须含字母和数字，建议使用密码管理器生成": "{{min}}–64 characters with letters and numbers. We recommend a password manager.",
  "英文": "English",
  "中文": "Chinese",
  "未填写的英文字段使用中文内容。": "Empty English fields use the Chinese content."
}
